import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {CclControlValueAccessor} from "../ccl-control-value-accessor";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {UploadChangeParam, UploadFile} from "ng-zorro-antd";
import {_copyObj, _find, _findIndex, isArray} from "../../ccl-util";

@Component({
    selector: 'ccl-upload',
    templateUrl: './upload.component.html',
    styleUrls: ['./upload.component.css'],
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: UploadComponent, multi: true}]
})
export class UploadComponent extends CclControlValueAccessor {

    // ä¸ä¼ æä»¶æå¡å¨å°å
    @Input()
    action = '';

    // éå¶æä»¶ç±»å(é«çæ¬æµè§å¨ææ)
    @Input()
    accept = '';

    // å¨å å¥æä»¶éååï¼å¤çï¼è¿åfalseæ¶ï¼ä¸å å¥ä¸ä¼ éå
    @Input()
    beforeUpload: (file: UploadFile) => boolean;

    // ä¸ä¼ æä»¶å±ç¤ºæ¹å¼
    @Input()
    listType: 'text' | 'picture' | 'picture-card' = 'text';

    // æ¯å¦åè®¸å¤é
    @Input()
    multiple = false;

    // èªå®ä¹è¯·æ±å¤´
    @Input()
    headers = {};

    // ä¸ä¼ æ¶åæ°åç§°ï¼é»è®¤ file
    @Input()
    name = 'file';

    // ä¸ä¼ æ¶åéçåæ°ï¼é»è®¤{}
    @Input()
    uploadParam: Object | ((file: UploadFile) => Object) = {};

    // å¨ä¸ä¼ æ¶ï¼æ¯å¦æºå¸¦ cookieï¼é»è®¤false
    @Input()
    withCredentials = false;

    // å½æä»¶ç§»é¤ä¹åï¼è§¦å,è¿åfalseï¼å°åæ¶æä»¶ç§»é¤
    @Input()
    beforeRemove: (file: UploadFile) => boolean;

    // ç»ä»¶çfileåè¡¨
    fileList: UploadFile[] = [];

    constructor(cdr: ChangeDetectorRef) {
        super(cdr);
    }

    // ç¨ä½åæ¾æ¯æ
    // è¥ç¨æ¥å±ç¤ºå¾çï¼éè¦æä¾ thumbUrl å±æ§(ç¨ä»¥æ¾ç¤ºç¼©ç¥å¾)
    writeValue(obj: any): void {
        if (obj && isArray(obj)) {
            this.value = obj;
            this.fileList = _copyObj(obj);
        } else {
            this.value = [];
            this.fileList = [];
        }
    }

    /**
     * å½ä¸ä¼ ç¶æåçååæ¶
     */
    changeValue(event: UploadChangeParam) {
        const {type, file} = event;
        if (type === 'success') {
            const response = file.response;

            if (response.code === 0) { // ä¸ä¼ æå
                this.value.push({
                    uid: file.uid,
                    name: file.name,
                    status: file.status,
                    response: response.data
                });

                this.onChange(this.value);
            } else {
                // ä¸ä¼ æåï¼è¿éå¿é¡»éè¿uidä¸»å¨æ¾å° fileListä¸­ç fileå¯¹è±¡ï¼èä¸æ¯ç´æ¥ä½¿ç¨eventåæ°ä¸­çfile(å¹¶ä¸æ¯åä¸ä¸ªå¯¹è±¡)
                const srcFile: UploadFile = _find(this.fileList, 'uid', file.uid);

                srcFile.status = 'error';
                srcFile.message = response.msg || 'ä¸ä¼ å¤±è´¥';
            }
        }
    }

    // å°è¯å å¥ä¸ä¼ éåï¼è¿åfalseæç»å å¥ä¸ä¼ éåï¼åæ°æ¯å½ååå¤å å¥ä¸ä¼ éåçfile
    uploadFile() {
        return (file: UploadFile) => {
            if (this.beforeUpload && this.beforeUpload(file) === false) {
                return false;
            }

            this.onTouched && this.onTouched();
        }
    }

    // å°è¯ç§»é¤æä»¶
    removeFile() {
        return (file: UploadFile) => {
            if (this.beforeRemove && this.beforeRemove(file) === false) {
                return false;
            }

            const idx2 = _findIndex(this.fileList, 'uid', file.uid);
            if (idx2 > -1) {
                this.fileList.splice(idx2, 1);
            }

            const idx = _findIndex(this.value, 'uid', file.uid);
            if (idx > -1) {
                this.value.splice(idx, 1);
                this.onChange(this.value);
            }

            return false;
        };
    }
}
